<app-email-verify-info [beneficiary]="beneficiary()"></app-email-verify-info>
<div class="flex flex-col gap-10">
  <p-card header="Dane osobowe" tabindex="0" class="custom-card">
      <app-preview-beneficiary-details
        [beneficiary]="beneficiary()"
      ></app-preview-beneficiary-details>
    </p-card>
  <p-card header="Dane kontaktowe" tabindex="0" class="custom-card">
      <app-preview-contact-details
        [beneficiary]="beneficiary()"
      ></app-preview-contact-details>
    </p-card>
    <app-preview-beneficiary-address
      [beneficiary]="beneficiary()!"
    ></app-preview-beneficiary-address>
  <p-card header="Numer konta bankowego" tabindex="0" class="custom-card">
    <app-preview-account-number
      [bankAccount]="beneficiary().kontoBankowe!"
    ></app-preview-account-number>
  </p-card>
  <div class="flex justify-end mt-4 mt-6 gap-2">
    <p-button
      styleClass="customInfoButton outlined"
      label="Wstecz"
      (click)="goToHomepage()"
    ></p-button>
    <p-button
      styleClass="customInfoButton"
      label="Edytuj"
      (click)="navigateToEditUser()"
    ></p-button>
  </div>
</div>
